import styled from '@emotion/styled';
import { TextField } from '@mui/material';
import { colors } from 'theme/colors';

interface StyledTextFieldProps {
  disabled?: boolean;
  multiline?: boolean;
  code?: boolean;
}

export const StyledTextField = styled(TextField)<StyledTextFieldProps>(
  ({ disabled, multiline, code }) => ({
    fieldset: {
      borderRadius: 4,
    },
    input: {
      fontSize: 14,
      backgroundColor: `${colors.white}`,
      borderRadius: '4px',
      boxSizing: 'border-box',
      ...(disabled ? { backgroundColor: colors.gray100 } : {}),
    },
    textarea: {
      fontSize: 14,
      padding: '12px',
    },
    'input::placeholder, textarea::placeholder': {
      fontSize: 14,
      fontWeight: 400,
      color: `${colors.gray400}`,
      fontFamily: 'NotoSansRegular, sans-serif',
      opacity: 1,
    },
    '& .MuiInputBase-adornedEnd': {
      padding: '0',
      ...(multiline ? { display: 'flex', alignItems: 'stretch' } : {}),
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: '16px',
      paddingBottom: '16px',
    },
    '& .MuiOutlinedInput-root': {
      ...(code ? { width: '50px', padding: '15px 0' } : {}),
      marginBottom: 3,
      backgroundColor: `${colors.white}`,

      ' & fieldset ': {
        borderColor: colors.gray400,
        borderWidth: '1px',
      },

      '&:hover:not(.Mui-focused, .Mui-disabled) fieldset ': {
        borderColor: colors.primary400,
      },

      '&.Mui-focused fieldset ': {
        borderColor: colors.primary400,
        borderWidth: '2px',
      },

      '&:active fieldset ': {
        borderColor: colors.primary900,
        borderWidth: '1px',
      },

      '&.Mui-error fieldset ': {
        borderColor: colors.error800,
        borderWidth: '1px',
      },

      '& ~ .Mui-error': {
        color: colors.error800,
      },

      '& .MuiInputAdornment-root .MuiIconButton-root ': {
        color: colors.gray900,
      },

      '&.Mui-disabled .MuiInputAdornment-root .MuiIconButton-root ': {
        color: colors.gray400,
      },

      '& ~ p': {
        marginLeft: '0px',
      },
    },
    '& .MuiOutlinedInput-root:has(textarea)': {
      padding: 0,
    },
    '& .MuiBox-root': {
      borderEndEndRadius: '4px',
      borderStartEndRadius: '4px',
    },
  }),
);
